import angular from 'angular';
import { SharedAngular } from '@Client/@types/sharedAngular';
import { FlowinglyPermissions } from '@Shared.Angular/flowingly.services/flowingly.constants';
import { IStateService } from 'angular-ui-router';
import { STATE_MAPPINGS } from '@Shared.Angular/@types/stateMappings';

angular.module('flowingly.runner.library').config(config);
config.$inject = ['$stateProvider'];

function config($stateProvider) {
  $stateProvider.state(STATE_MAPPINGS.libraryFormThemes, {
    url: '/formthemes',
    params: { title: 'Library -  Form Themes' },
    views: {
      childcontent: {
        controllerAs: '$ctrl',
        controller: [
          'APP_CONFIG',
          '$state',
          'permissionsService',
          function (
            APP_CONFIG: SharedAngular.APP_CONFIG,
            $state: IStateService,
            permissionsService: SharedAngular.PermissionsService
          ) {
            const canAccessFormThemes =
              APP_CONFIG.allowWorkflow &&
              permissionsService.currentUserHasAnyOfPermissions([
                FlowinglyPermissions.FORM_THEME_CREATE,
                FlowinglyPermissions.FORM_THEME_PUBLISH,
                FlowinglyPermissions.FORM_THEME_DELETE
              ]);
            if (!canAccessFormThemes) {
              $state.go(STATE_MAPPINGS.library);
            }
          }
        ],
        template:
          '<runner-library-tabs></runner-library-tabs>' +
          '<library-form-themes-grid></library-form-themes-grid>'
      }
    }
  });
}
